module.exports = __webpack_public_path__ + "static/img/1.4374916.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pcho/22/1.png
// module id = bQo2
// module chunks = 0